import type { LineItemFormFieldConfig } from './SharedLineItemFormContent';

export const LINE_ITEM_FIELD_CONFIG: LineItemFormFieldConfig = {
  nameFieldPath: 'modifiedName',
  descriptionFieldPath: 'modifiedDescription',
  priceFieldPath: 'modifiedPrice',
  isNameRequired: false,
  taxRateFieldPath: 'saleTax.modifiedSaleTax',
};
